import React from 'react';

export const retryLazy = (
  importFunc: () => Promise<any>,
  retries = 3,
  delay = 500
) => {
  return React.lazy(
    () =>
      new Promise((resolve, reject) => {
        const attempt = (retryCount: number) => {
          importFunc()
            .then(resolve)
            .catch((error) => {
              if (
                error.name === 'ChunkLoadError' ||
                error.message?.includes('Loading chunk')
              ) {
                if (retryCount <= 0) {
                  // Final fallback: reload the page
                  window.location.reload();
                } else {
                  setTimeout(() => attempt(retryCount - 1), delay);
                }
              } else {
                reject(error); // Not a chunk error
              }
            });
        };

        attempt(retries);
      })
  );
};
